<template>
  <div class="shop-settings-password">
    <v-row>
      <transition name="fade" mode="out-in">
        <v-col cols="12" v-if="!getIsSubscribed" key="not-subscribed">
          <v-alert text color="info" outlined>
            <v-row align="center" dense>
              <v-col cols="12" class="title black--text">
                Your subscription isn't active yet.
                <transition name="fade">
                  <div v-if="error" class="body-2"
                    >Something went wrong. Please try again or email
                    <a href="mailto:hi@getminimart.com">hi@getminimart.com</a
                    >.</div
                  >
                </transition>
              </v-col>
              <v-col cols="12">
                <BtnBaseOrange
                  @click="requestSubscriptionCheckoutUrl"
                  :loading="loading"
                  >Subscribe</BtnBaseOrange
                >
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
        <v-col v-else key="active-subscription">
          <div class="title">Your Subscription is Active.</div>
          <BtnBaseBlue
            @click="requestStripePortalSession"
            :loading="loading"
            depressed
            :disabled="!getIsSubscribed"
            class="d-inline"
            color="blue darken-2 white--text"
            >Manage in Stripe
          </BtnBaseBlue>
          <div v-if="portalSessionUrl" class="body-2">
            Sending you to Stripe...
          </div>
          <transition name="fade">
            <div v-if="error" class="body-2"
              >Something went wrong. Please try again or email
              <a href="mailto:hi@getminimart.com">hi@getminimart.com</a>.</div
            >
          </transition>
        </v-col>
      </transition>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ShopModel from '@/models/ShopModel'
import _get from 'lodash/get'

import BtnBaseBlue from '@/components/BtnBaseBlue'
import BtnBaseOrange from '@/components/BtnBaseOrange'
export default {
  name: 'ShopSettingsBilling',
  components: { BtnBaseBlue, BtnBaseOrange },
  data() {
    return {
      loading: false,
      checkoutUrl: null,
      portalSessionUrl: null,
      error: null,
    }
  },
  methods: {
    async requestSubscriptionCheckoutUrl() {
      this.loading = true
      this.error = null
      try {
        let response = await ShopModel.getSubscriptionCheckoutUrl(
          this.getShopId
        )
        let urlObj = _get(response, 'response.data.data', {})

        this.checkoutUrl = urlObj.checkoutUrl
        window.location.href = this.checkoutUrl
      } catch (error) {
        this.loading = false
        this.error = error
      }
    }, // requestSubscriptionCheckoutUrl

    async requestStripePortalSession() {
      this.loading = true
      this.error = null
      try {
        let response = await ShopModel.getStripePortalSession(this.getShopId)
        let urlObj = _get(response, 'response.data.data', {})
        this.portalSessionUrl = urlObj.session_url
        window.location.href = this.portalSessionUrl
      } catch (error) {
        this.loading = false
        this.error = error
      }
    }, // requestStripePortalSession
  },
  computed: {
    ...mapGetters('shop', ['getShopId', 'getIsSubscribed']),
  },
}
</script>
